<div class="tw-relative">
  @if (isSignal()) {
    <ng-container *ngTemplateOutlet="signalPulse; context: { delay: '0s' }"></ng-container>
    <ng-container *ngTemplateOutlet="signalPulse; context: { delay: '1s' }"></ng-container>
  }
  <ng-content></ng-content>
</div>

<ng-template #signalPulse let-delay="delay">
  <div
    [ngClass]="[
      'tw-pointer-events-none tw-absolute tw-inset-0 tw-animate-signal-glow tw-rounded-full',
      adjustmentClasses(),
    ]"
    [ngStyle]="{ 'animation-delay': delay }"
  ></div>
</ng-template>
